document.addEventListener('DOMContentLoaded', function () {
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImage = document.getElementById('ProductMainImage');
  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-full');
      });
    });
  }
});
